export const environment = {
	production: true,
	
	baseUrl: 'https://api.rpatechnologies.in/',
	apiUrl: 'https://api.rpatechnologies.in/api/',
	uploadUrl: 'https://api.rpatechnologies.in/uploads/',
	blogUrl:'https://api.rpatechnologies.in/api/proweb/',
};
